module.exports = __webpack_public_path__ + "static/media/finished-book.37b13f5f.svg";